<div class="container">
  <div class="header">
    <pdq-heading element="h3">Deactivate workstation</pdq-heading>
    <pdq-button
      (onClick)="dialogRef.close()"
      iconColor="var(--on-surface-light)"
      variant="ghost"
      icon="close"></pdq-button>
  </div>
  <div class="wrapper">
    <div class="content">
      <span> Are you sure you want to deactivate {{ workstation.name }} </span>
    </div>
  </div>
  <footer style="justify-content: flex-end">
    <pdq-button label="Cancel" (onClick)="dialogRef.close()"></pdq-button>
    <pdq-button variant="danger" label="Deactivate" (click)="deactivate()"></pdq-button>
  </footer>
</div>
